import { Navigate, useNavigate } from 'react-router-dom';
import { addToCart, updateCartQuantity, removeFromCart } from '../store/slices/UserDetailsSlice';
import { toastSuccess, toastError } from './toastUtil';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { getBaseUrl } from './setBaseUrl';

// Phone number normalization function - always use plain number (without +91)
export const normalizePhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return phoneNumber;
  
  // Remove +91 prefix if present
  if (phoneNumber.startsWith('+91')) {
    return phoneNumber.slice(3);
  }
  
  // Remove any other country code patterns if present
  if (phoneNumber.startsWith('+')) {
    // For other country codes, you might want to handle differently
    // For now, just return as is if it's not +91
    return phoneNumber;
  }
  
  return phoneNumber;
};

const userAccessToken = localStorage.getItem('userAccessToken')
const userSession = JSON.parse(localStorage.getItem('userSession'))
const baseUrl = getBaseUrl()
// const { baseUrl } = useSelector((state) => state.apiBaseUrl)


export const setUserData = async (updatedCart) => {
 
  try {
    // Normalize phone number from userSession
    const normalizedPhone = normalizePhoneNumber(userSession?.user?.phoneNumber);
    
    const response = await axios.post(`${baseUrl}api/customer-search-create/`, {
      username: normalizedPhone,
      password: normalizedPhone,
      communication_consent: localStorage.getItem('communication_consent_decision') === 'agreed'
    }, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: false  // <--- prevent sending cookies
    });
    
    let createData = response?.data
    console.log('user details', response?.data)
    try {
      const alteredCartItems = updatedCart.map((cartItem) => ({ 
          item: cartItem.item_id || cartItem.id, 
          variant_id: cartItem.variant?.id || null,
          quantity: cartItem.quantity 
      }))
      console.log(alteredCartItems,"alteredcartitems")
      const response = await axios.patch(`${baseUrl}api/customers/${createData?.customer_id}/`, {
          "cart_items": alteredCartItems
      })

    } catch (error) {
      console.log(error);
    }
  } catch (error) {
    console.log("error while getting user category data", error?.response?.message)
  }
}

// Add or update the cart item
export const handleAddToCart = (product, dispatch, quantity, cartItems, variant = null, purchaseTier = 'READY_STOCK') => {
  const tier = purchaseTier || 'READY_STOCK';
  const cartItemsInLocalStorage = JSON.parse(localStorage.getItem("cartItems")) || [];
  
  // Create a unique cartItemId for local state management (including tier so ready stock & pre-book don't collide)
  const cartItemId = variant ? `${product.id}_${variant.id}_${tier}` : `${product.id}_${tier}`;
  
  const existingProduct = cartItemsInLocalStorage.find(item => item.cartItemId === cartItemId || (!item.cartItemId && item.id === product.id && (item.purchase_tier || 'READY_STOCK') === tier));
  
  // Ensure quantity is at least the minimum order quantity
  const minQuantity = product.min_order_quantity || 1;
  const newQuantity = Math.max(minQuantity, quantity || minQuantity);
  
  const maxStock = tier === 'PRE_BOOK' ? 10000 : (variant ? variant.stock : product.stock);

  if (existingProduct) {
    if (tier !== 'PRE_BOOK' && existingProduct.quantity + newQuantity > maxStock) {
       toastError('Out of stock! No more items available for now.');
       return;
    }
    // Increase quantity if product already exists
    const updatedCart = cartItemsInLocalStorage.map(item =>
      (item.cartItemId === cartItemId || (!item.cartItemId && item.id === product.id && (item.purchase_tier || 'READY_STOCK') === tier)) ? { ...item, quantity: item.quantity + newQuantity } : item
    );
    localStorage.setItem("cartItems", JSON.stringify(updatedCart));
    sessionStorage.setItem("cartItems", JSON.stringify(updatedCart));

    if (userAccessToken) {
      setUserData(updatedCart)
        .then(() => console.log("User data successfully updated."))
        .catch((error) => console.error("Failed to update user data:", error));
    }

    dispatch(updateCartQuantity({ id: cartItemId, quantity: existingProduct.quantity + newQuantity }));
    toastSuccess("Item added to cart");
  } else {
    if (tier !== 'PRE_BOOK' && newQuantity > maxStock) {
       toastError('Out of stock! No more items available for now.');
       return;
    }
    // Add new product to cart with minimum quantity
    const newCartItem = { 
        ...product, 
        cartItemId, 
        item_id: product.id,
        variant,
        purchase_tier: tier,
        // Override price if variant has specific price
        price: variant && variant.price ? variant.price : product.price,
        quantity: newQuantity 
    };
    const updatedCart = [...cartItemsInLocalStorage, newCartItem];
    localStorage.setItem("cartItems", JSON.stringify(updatedCart));
    sessionStorage.setItem("cartItems", JSON.stringify(updatedCart));

    if (userAccessToken) {
      setUserData(updatedCart)
        .then(() => console.log("User data successfully updated."))
        .catch((error) => console.error("Failed to update user data:", error));
    }

    dispatch(addToCart({ ...newCartItem }));
  }
  toastSuccess("Item added to cart");
};

// Increase the quantity of an item
export const increaseCartItemQuantity = (cartItemId, dispatch) => {
  const cartItemsInLocalStorage = JSON.parse(localStorage.getItem("cartItems")) || [];
  const product = cartItemsInLocalStorage.find(item => item.cartItemId === cartItemId || item.id === cartItemId);
  if (!product) return;
  const minQuantity = parseInt(product?.min_order_quantity, 10) || 1;
  const maxStock = product?.variant ? product.variant.stock : product.stock;

  if (product.quantity + minQuantity > maxStock) {
     toastError('Out of stock! No more items available for now.');
     return;
  }

  const updatedCart = cartItemsInLocalStorage.map(item =>
    (item.cartItemId === cartItemId || item.id === cartItemId) ? { ...item, quantity: item.quantity + minQuantity } : item
  );
  localStorage.setItem("cartItems", JSON.stringify(updatedCart));
  sessionStorage.setItem("cartItems", JSON.stringify(updatedCart));

  if (userAccessToken) {
    setUserData(updatedCart)
      .catch((error) => console.error("Failed to update user data:", error));
  }

  const updatedItem = updatedCart.find(item => item.cartItemId === cartItemId || item.id === cartItemId);
  dispatch(updateCartQuantity({ id: cartItemId, quantity: updatedItem.quantity }));
};

// Decrease the quantity of an item (remove if quantity is at minimum)
export const decreaseCartItemQuantity = (cartItemId, dispatch) => {
  const cartItemsInLocalStorage = JSON.parse(localStorage.getItem("cartItems")) || [];
  const existingProduct = cartItemsInLocalStorage.find(item => item.cartItemId === cartItemId || item.id === cartItemId);
  const minQuantity = parseInt(existingProduct?.min_order_quantity, 10) || 1;

  if (existingProduct.quantity > minQuantity) {
    // Decrease quantity
    const updatedCart = cartItemsInLocalStorage.map(item =>
      (item.cartItemId === cartItemId || item.id === cartItemId) ? { ...item, quantity: item.quantity - minQuantity } : item
    );
    localStorage.setItem("cartItems", JSON.stringify(updatedCart));
    sessionStorage.setItem("cartItems", JSON.stringify(updatedCart));

    if (userAccessToken) {
      setUserData(updatedCart)
        .catch((error) => console.error("Failed to update user data:", error));
    }

    dispatch(updateCartQuantity({ id: cartItemId, quantity: existingProduct.quantity - minQuantity }));
  } else {
    // If quantity is at minimum, remove the item
    removeCartItem(cartItemId, dispatch);
  }
};

// Remove an item from the cart
export const removeCartItem = (cartItemId, dispatch) => {
  const cartItemsInLocalStorage = JSON.parse(localStorage.getItem("cartItems")) || [];
  const updatedCart = cartItemsInLocalStorage.filter(item => item.cartItemId !== cartItemId && item.id !== cartItemId);
  localStorage.setItem("cartItems", JSON.stringify(updatedCart));
  sessionStorage.setItem("cartItems", JSON.stringify(updatedCart));

  if (userAccessToken) {
    setUserData(updatedCart)
      .catch((error) => console.error("Failed to update user data:", error));
  }

  dispatch(removeFromCart(cartItemId));
  toastSuccess("Item removed from cart");
};

export const logoutAffiliate = (navigate) => {
  sessionStorage.removeItem('affiliateAccess');
  sessionStorage.removeItem('affiliateRefresh');
  sessionStorage.removeItem('affiliate_username');
  if(navigate) {
    navigate('/affiliate');
  }
};






